import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuoteModal from '../../../components/feature/QuoteModal';

const guarantees = [
  {
    icon: 'ri-thumb-up-line',
    color: 'from-brand-green to-brand-green-dark',
    tKey: 'guar_t1',
    dKey: 'guar_d1',
  },
  {
    icon: 'ri-user-follow-line',
    color: 'from-brand-blue to-brand-blue-dark',
    tKey: 'guar_t2',
    dKey: 'guar_d2',
  },
  {
    icon: 'ri-leaf-line',
    color: 'from-brand-green-dark to-brand-blue',
    tKey: 'guar_t3',
    dKey: 'guar_d3',
  },
  {
    icon: 'ri-time-line',
    color: 'from-brand-blue-dark to-brand-green',
    tKey: 'guar_t4',
    dKey: 'guar_d4',
  },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-14">
            <span className="text-brand-green font-semibold text-sm uppercase tracking-wider">
              {t('rev_eyebrow')}
            </span>
            <h2 className="font-heading font-bold text-brand-blue-dark text-4xl mt-2 mb-4">
              {t('rev_heading')}
            </h2>
            <p className="text-gray-500 text-sm max-w-lg mx-auto leading-relaxed">
              {t('rev_sub')}
            </p>
            <div className="w-16 h-1 bg-brand-green rounded-full mx-auto mt-5" />
          </div>

          {/* Guarantee Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
            {guarantees.map((g) => (
              <div key={g.tKey} className="bg-white rounded-2xl p-7 text-center">
                <div
                  className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${g.color} mx-auto mb-5`}
                >
                  <i className={`${g.icon} text-white text-2xl`} />
                </div>
                <h3 className="font-semibold text-brand-blue-dark text-sm mb-2">
                  {t(g.tKey)}
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed">{t(g.dKey)}</p>
              </div>
            ))}
          </div>

          {/* Be First Client Banner */}
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-brand-blue-dark to-brand-green-dark p-10 text-center">
            {/* subtle decorative circles */}
            <div className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white/5" />
            <div className="absolute -bottom-14 -right-6 w-52 h-52 rounded-full bg-white/5" />

            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/10 border border-white/20 mx-auto mb-5">
                <i className="ri-star-smile-line text-white text-3xl" />
              </div>
              <h3 className="font-heading font-bold text-white text-3xl mb-3">
                {t('guar_first_h')}
              </h3>
              <p className="text-white/70 text-sm max-w-xl mx-auto mb-8 leading-relaxed">
                {t('guar_first_d')}
              </p>
              <button
                onClick={() => setQuoteOpen(true)}
                className="inline-flex items-center gap-3 bg-white text-brand-green-dark hover:bg-brand-green hover:text-white font-bold px-10 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line text-lg" />
                {t('guar_first_btn')}
              </button>
            </div>
          </div>
        </div>
      </section>

      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </>
  );
}
